import React from 'react';
import { Route } from 'react-router-dom';

import { AUTHCOOKIENAME } from '../../../config/routes';
import { useCookies } from 'react-cookie'

const PrivateRoute = (props) => {
  const [cookies] = useCookies([AUTHCOOKIENAME]);

  if(cookies[AUTHCOOKIENAME]) {
    return(
      <Route path={props.path} render= {() => props.children }/>
    )
  } else {
    return (
      <div className="page-container">
        <div className="main-header"></div>
        <div className="page-header page-header--fixed">
          <h3>Checking User Credentials</h3>
        </div>
      </div>
    )
  }
}

export default PrivateRoute;